// Global config file

export const global = {
    httpAuth: {
        username: '1',
        password: '1',
    },

    wp: {
        env: {
            prod: { protocol: 'https' },
            stage: { protocol: 'https', subdomain: 'test-wp' },
            test: { protocol: 'http', subdomain: 'test-wp' },
            local: { protocol: 'http', subdomain: 'local' },
        },
    },

    website: {
        env: {
            prod: { protocol: 'https' },
            stage: { protocol: 'http', subdomain: 'test-wp' },
            test: { protocol: 'http', subdomain: 'test-wp' },
            local: { protocol: 'http', subdomain: 'd-local', port: 4241 },
        },
        local: {
            assets: '/website-assets',
            images: '/website-assets/images',
            sentryTagsNode: {
                component: 'BACKEND',
                environment: 'staging',
                brand: '',
            },
        },
        production: {
            assets: '/website-assets',
            images: '/website-assets/images',
            sentryTagsNode: {
                component: 'BACKEND',
                environment: 'staging',
                brand: '',
            },
        },
    },

    mobile: {
        env: {
            prod: { protocol: 'https' },
            stage: { protocol: 'http', subdomain: 'm-stage' },
            test: { protocol: 'http', subdomain: 'm-test' },
            local: { protocol: 'http', subdomain: 'm-local', port: 4240 },
        },
    },

    frontend: {
        env: {
            prod: { protocol: 'https', subdomain: 'frontend' },
            stage: { protocol: 'https', subdomain: 'frontend-staging' },
            test: { protocol: 'http', subdomain: 'frontend.develop.sandbox' },
            local: { protocol: 'http', subdomain: 'local', port: 3000 },
        },
    },
};
export const frontend = {
    aws: {
        mobile: {
            aws_project_region: 'eu-central-1',
            aws_appsync_region: 'eu-central-1',
            aws_appsync_authenticationType: 'API_KEY',
            aws_appsync_apiKey: 'da2-f6zedtvklrhmbjwaps42f7xupe',
        },
    },
    logEnabled: true,
    logLevel: 'info',
};
export const SCHEMA_CONTEXT = 'http://schema.org';
export const website = {};
